import FetchHelpers from "../fetch-helpers";

let fetchData = new FetchHelpers().fetchData;
let accordion_data = document.querySelector('#sets-accordion').dataset;
let url = accordion_data.url;
let pub_type = accordion_data.pubType;

/**
 * Load all the volume titles in a set as second-level accordions.
 * @param element
 * @returns {Promise<void>}
 */
async function load_volumes(element) {
  let data = {
    'target': 'volumes',
    'pub_type': pub_type,
    'stub': element.dataset.stub,
    'range': element.dataset.range
  }

  let response = await fetchData('POST', url, data);
  if(response['error']) {
    console.log(response['error'].toString());
    element.innerHTML  = response['error'];
    element.setAttribute('data-loaded', "false");
  } else {
    let contentElem = element.querySelector('.accordion-content');
    contentElem.innerHTML = response['accordion-content'];
    jQuery(contentElem).foundation();

    element.setAttribute('data-loaded', "true");
  }
}

/**
 * Load the contents of a volume accordion (the toc items)
 * @param element
 * @returns {Promise<void>}
 */
async function load_series_content(element) {
  let contentElem = element.querySelector('.accordion-content');
  let pub_type = document.querySelector('#sets-accordion').dataset.pubType;
  let data = {
    'target': 'series',
    'pub_type': pub_type,
    'stub': element.dataset.stub,
    'volume': element.dataset.volume
  }

  const response = await fetchData('POST', url, data);
  if (response['error']) {
    console.log(response['error']);
    element.innerHTML = "<div id='error'>There was an error loading content. Please try again later by closing and reopening this accordion or refreshing the page.</div>";
    element.setAttribute('data-loaded', "false");
  } else {
    if(response['accordion-content']) {
      contentElem.innerHTML = response['accordion-content'];
      element.setAttribute('data-loaded', "true");

    } else {
      let errDiv = document.createElement('div');
      errDiv.innerText = "There was an error fetching content. Please try again later."
      contentElem.replaceChildren(errDiv);
    }
  }

  jQuery(contentElem).foundation();
}

/**
 * Load the volume accordions for all sets and the contents of the selected volume. Open the selected set and volume accordions.
 * Send both the range and volume info to the backend. This lets the backend script know that we are loading both the
 * selected set volumes accordions and the contents of the selected volume as well.
 * @param element
 * @returns {Promise<void>}
 */
async function load_volumes_and_select_series(element) {
  let contentElem = element.querySelector('.accordion-content');
  let pub_type = document.querySelector('#sets-accordion').dataset.pubType;
  let data = {
    'target': 'series',
    'pub_type': pub_type,
    'stub': element.dataset.stub,
    'range': element.dataset.range,
    'volume': element.dataset.volume
  }

  let response = await fetchData('POST', url, data);
  if (response['error']) {
    console.log(response['error']);
    element.innerHTML = "<div id='error'>There was an error loading content. Please try again later by closing and reopening this accordion or refreshing the page.</div>";
    element.setAttribute('data-loaded', "false");
  } else {
    if(response['accordion-content']) {
      contentElem.innerHTML = response['accordion-content'];
      element.setAttribute('data-loaded', "true");
    } else {
      let errDiv = document.createElement('div');
      errDiv.innerText = "There was an error fetching content. Please try again later."
      contentElem.replaceChildren(errDiv);
    }
  }

  jQuery(contentElem).foundation();
}

/* Adds content to accordion on open */
document.querySelector('#sets-accordion').addEventListener("click", async function (e) {
  const element = e.target;
  let li;


  // If the element exists, but it isn't the list item itself (might be the 'a' link) go to the parent element instead.
  if(element) {
    let { parentNode = null, tagName = null } = element;
    li = element;

    while (li && li !== this && tagName.toUpperCase() !== "LI") {
      li = parentNode;
      tagName = li.tagName;
    }

    // load volumes data if not loaded
    if (!li.dataset.hasOwnProperty('loaded')) {
      li.dataset.loaded = 'false';
    }

    if (li && li.matches("li.accordion-item") && li.dataset.loaded === 'false') {

      // Load the list of volumes in a set into set accordion
      if (li.dataset.range) {
        await load_volumes(li);
      }

      // load the contents (TOC) into the selected volume accordion
      if (li.dataset.volume) {
        await load_series_content(li);
      }
    }
  }
});
